module.exports = __webpack_public_path__ + "assets/img/right-title-open-730c44be.png";